import { useCallback } from "react";
import useStore from "../store";

const useEdgesInteractions = () => {
  const edges = useStore((state) => state.edges);
  const setEdges = useStore((state) => state.setEdges); // 不会触发onEdgesChange

  const handleEdgeEnter = useCallback(
    (_, { id }) => {
      const newEdges = edges.map((edge) => {
        if (edge.id === id) {
          return {
            ...edge,
            data: {
              ...edge.data,
              _hovering: true,
            },
          };
        }
        return edge;
      });
      setEdges(newEdges);
    },
    [edges, setEdges]
  );

  const handleEdgeLeave = useCallback(
    (_, { id }) => {
      const newEdges = edges.map((edge) => {
        if (edge.id === id) {
          return {
            ...edge,
            data: {
              ...edge.data,
              _hovering: false,
            },
          };
        }
        return edge;
      });
      setEdges(newEdges);
    },
    [edges, setEdges]
  );

  return {
    handleEdgeEnter,
    handleEdgeLeave,
  };
};

export default useEdgesInteractions;
